import UserSumSubDocumentPreview from './UserSumSubDocumentPreview';

export default UserSumSubDocumentPreview;
